import React, { useState, useEffect } from "react";
import {
    collection,
    getDocs,
    query,
    where,
    doc,
    writeBatch,
    updateDoc
} from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";

const BulkAgeRangeUpdate = () => {
    const [users, setUsers] = useState([]); // from funder_users_list
    const [loaded, setLoaded] = useState(false);
    const [running, setRunning] = useState(false);
    const [result, setResult] = useState({ updated: 0, failed: 0 });

    // Step 1: load funder_users_list
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const colRef = collection(db, "funder_users_list");
                const snap = await getDocs(colRef);
                const arr = snap.docs.map(d => {
                    const data = d.data();
                    return {
                        id: d.id,
                        phone: String(data.phone_no || data.phone || "").trim(),
                        age_range: data.age_range || ""
                    };
                }).filter(u => u.phone);
                setUsers(arr);
            } catch (err) {
                console.error("Error fetching funder_users_list:", err);
                Swal.fire("Error", "Could not load users", "error");
            } finally {
                setLoaded(true);
            }
        };

        fetchUsers();
    }, []);

    const handleSync = async () => {
        if (!loaded) {
            Swal.fire("Info", "Still loading data...", "info");
            return;
        }
        if (users.length === 0) {
            Swal.fire("Info", "No users to sync", "info");
            return;
        }

        setRunning(true);
        let updated = 0;
        let failed = 0;

        const BATCH_LIMIT = 400;

        for (let i = 0; i < users.length; i += BATCH_LIMIT) {
            const chunk = users.slice(i, i + BATCH_LIMIT);
            const batch = writeBatch(db);

            for (let u of chunk) {
                try {
                    const { phone, age_range } = u;
                    if (!phone) {
                        failed++;
                        continue;
                    }

                    const q = query(
                        collection(db, "profile_type"),
                        where("phone_no", "==", phone)
                    );
                    const snap = await getDocs(q);
                    if (snap.empty) {
                        console.warn("Profile not found for", phone);
                        failed++;
                    } else {
                        snap.docs.forEach(docSnap => {
                            const ref = doc(db, "profile_type", docSnap.id);
                            // Only update age_range field
                            batch.update(ref, { age_range: age_range });
                        });
                        updated++;
                    }
                } catch (err) {
                    console.error("Error syncing for user", u.phone, err);
                    failed++;
                }
            }

            try {
                await batch.commit();
            } catch (err) {
                console.error("Batch commit failed:", err);
                // count chunk as failure
                failed += chunk.length;
            }
        }

        setRunning(false);
        setResult({ updated, failed });
        Swal.fire("Done", `Updated: ${updated}, Failed: ${failed}`, "success");
    };

    return (
        <div className="container p-4">
            <h3>Synchronize Age Range to profile_type</h3>
            {!loaded ? (
                <p>Loading users...</p>
            ) : (
                <>
                    <p>Total users to sync: {users.length}</p>
                    <button
                        className="btn btn-primary"
                        onClick={handleSync}
                        disabled={running}
                    >
                        {running ? "Syncing..." : "Start Sync"}
                    </button>
                    {(result.updated || result.failed) && (
                        <div className="mt-3">
                            <p>✅ Updated: {result.updated}</p>
                            <p>❌ Failed: {result.failed}</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default BulkAgeRangeUpdate;